module.exports = __webpack_public_path__ + "img/arrow-up-solid.25a9000e.svg";